module.exports = __webpack_public_path__ + "img/defBanner.70a6df88.png";